import { Link } from 'react-router-dom';
import { API } from '@/App';
import { GeoEventsPanel } from '@/components/internal-staff/geo-control/GeoEventsPanel';

export default function GeoControlReview({ user }) {
  const allowed = user?.role === 'admin' && (user.operations_manager || user.is_super_admin);
  if (!allowed) return <p className="p-6" data-testid="geo-review-forbidden">Accès réservé au responsable d’exploitation et au Super Admin.</p>;
  return <main className="max-w-4xl mx-auto px-4 py-8 space-y-6" data-testid="geo-review-page">
    <Link to="/operations/hours" className="text-sm underline" data-testid="geo-review-back">Retour aux pointages</Link>
    <h1 className="font-bold text-3xl">Exceptions de lieu</h1>
    <p className="text-sm text-slate-600" data-testid="geo-review-explanation">L’examen de l’exception ne modifie ni le résultat géographique initial ni les heures déclarées. La validation des heures reste distincte.</p>
    <GeoEventsPanel base={`${API}/internal-staff`} actor={user.is_super_admin ? 'superadmin' : 'manager'} />
  </main>;
}